import React, { useEffect, useState } from 'react';
import moment from 'moment-jalaali'

export default function Footer() {

  const [time, setTime] = useState(moment().format('HH:mm'))
  let id: any = null
  useEffect(() => {
    id = window.setInterval(() => {
      setTime(moment().format('HH:mm'))
    }, 1000)
    return () => {
      clearInterval(id)
    }
  }, [time])

  return (
    <footer className='px-10 bg-gray-100 w-full bottom-0 right-0 left-0 text-right py-2'>
      <span className='font-bold block text-base'>{moment().format('jYYYY/jMM/jD')}</span>
      <span className='text-sm'>{time}</span>
    </footer>
  )
} 
